/* eslint-disable frontApplet/enforce-jsdoc */
import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IAppletCommandErrorParams extends IBaseSosErrorParams {
	kind: 'appletCommandError';
}

export default class AppletCommandError extends AppletError {
	public static readonly PATH_TO_DOCS: string = '/sdk/content/js-command';

	constructor(parameters: IAppletCommandErrorParams) {
		super({
			...parameters,
			type: parameters.type ? parameters.type : 'AppletCommandError',
			pathToDocs: AppletCommandError.PATH_TO_DOCS,
			kind: 'appletError',
		});
	}
}
